export default __webpack_public_path__ + "static/media/tete6.557bd4c7.png";